/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type NewsNewsType = "CONTENT_WITH_PICTURE" | "CONTENT_WITH_VIDEO" | "LINK_TYPE" | "%future added value";
export type AllNewsQueryVariables = {|
  politician?: ?string,
  party?: ?string,
  id?: ?string,
|};
export type AllNewsQueryResponse = {|
  +allNews: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +source: string,
        +shortDescription: string,
        +created: any,
        +link: ?string,
        +featuredImage: ?string,
        +featuredVideos: ?string,
        +newsContent: ?string,
        +newsType: NewsNewsType,
        +thumbnail: ?string,
      |}
    |}>
  |}
|};
export type AllNewsQuery = {|
  variables: AllNewsQueryVariables,
  response: AllNewsQueryResponse,
|};
*/


/*
query AllNewsQuery(
  $politician: ID
  $party: ID
  $id: ID
) {
  allNews(politician: $politician, party: $party, id: $id) {
    edges {
      node {
        id
        source
        shortDescription
        created
        link
        featuredImage
        featuredVideos
        newsContent
        newsType
        thumbnail
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "party"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "politician"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "party",
        "variableName": "party"
      },
      {
        "kind": "Variable",
        "name": "politician",
        "variableName": "politician"
      }
    ],
    "concreteType": "NewsNodeConnection",
    "kind": "LinkedField",
    "name": "allNews",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NewsNodeEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NewsNode",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "source",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "shortDescription",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "created",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "link",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "featuredImage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "featuredVideos",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "newsContent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "newsType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "thumbnail",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AllNewsQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AllNewsQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "a6c8a0d2b6ebec6a6e980616c859f6fb",
    "id": null,
    "metadata": {},
    "name": "AllNewsQuery",
    "operationKind": "query",
    "text": "query AllNewsQuery(\n  $politician: ID\n  $party: ID\n  $id: ID\n) {\n  allNews(politician: $politician, party: $party, id: $id) {\n    edges {\n      node {\n        id\n        source\n        shortDescription\n        created\n        link\n        featuredImage\n        featuredVideos\n        newsContent\n        newsType\n        thumbnail\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a1efbb5643aa5d004d8b2c56d4f7c500';

module.exports = node;
